import React from "react";
import Avatar from "../../avatar";
import { Championship } from "../../../types";

const PlayerItemMediumCard = ({ photoUrl, name, meta = null }: { photoUrl: string; name: string; meta: string }) => {
	return (
		<div className="item player card">
			<Avatar photoUrl={photoUrl} size="thumb6" />
			<div className="name">{name}</div>
			<div className="meta">{meta}</div>
		</div>
	);
};

export default PlayerItemMediumCard;
